import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import DrawService from '../../domain/DrawService';
import gs from '../../styles/style';
import Breadcrumbs from '../Common/Breadcrumbs';
import { useForm } from '../Common/Form';
import DrawForm from './DrawForm';
var AddDrawForm = function (_a) {
    var history = _a.history;
    var t = useTranslation()[0];
    var form = useForm({
        onSubmit: DrawService.addDraw,
        onSuccess: function (draw) { return history.push("/draws/".concat(draw.id)); }
    });
    return React.createElement("div", null,
        React.createElement(Breadcrumbs, null,
            React.createElement(Link, { to: "/draws" }, t('draws'))),
        React.createElement("div", { className: gs('section-header') },
            React.createElement("h1", { className: gs('section-title') }, t('add_draw'))),
        React.createElement(DrawForm, { form: form }));
};
export default withRouter(AddDrawForm);
